import { Component, OnInit } from '@angular/core';
import { GridkyProduct } from '@app/dao/simulation/simulation.interface';
import { SwiperOptions } from 'swiper';
import { EaGridkyService } from '../ea-gridky.service';

@Component({
    selector: 'ea-gridky-photo',
    templateUrl: './ea-gridky-photo.component.html',
    styleUrls: ['./ea-gridky-photo.component.scss'],
    standalone: false
})
export class EaGridkyPhotoComponent implements OnInit {
  config: SwiperOptions = {
    loop: true,
    autoplay: true,
    a11y: { enabled: true },
    direction: 'horizontal',
    slidesPerView: 1,
    breakpoints: undefined,
    threshold: 50,
    spaceBetween: 5,
    keyboard: true,
    mousewheel: false,
    scrollbar: false,
    navigation: true,
    pagination: false,
  };

  constructor(private gridkyService: EaGridkyService) {}

  ngOnInit() {
    this.gridkyService.productChanged.subscribe(this.renderSwiper.bind(this));
  }

  renderSwiper(newProduct: GridkyProduct) {}

  get product() {
    return this.gridkyService.product || undefined;
  }
}
